import initialStates from '../../initialStates';
import {
    CLEAR_ACCOUNT_INVOICE,
    FETCH_ACCOUNT_INVOICE_FAILURE,
    FETCH_ACCOUNT_INVOICE_SUCCESS,
} from './accountInvoiceTable-actions';

const accountInvoiceTableReducer = (state = initialStates.accountVoucherTable, action) => {
    let newState;
    switch (action.type) {
    case FETCH_ACCOUNT_INVOICE_SUCCESS:
        newState = {
            list: action.data.content,
            first: action.data.first,
            last: action.data.last,
            forwardSeekMap: action.data.forwardSeekMap,
            backwardSeekMap: action.data.backwardSeekMap,
            page: action.data.page,
            size: action.data.size,
        };
        break;
    case FETCH_ACCOUNT_INVOICE_FAILURE:
    case CLEAR_ACCOUNT_INVOICE:
        newState = { ...initialStates.debitAndCreditLines };
        break;
    default:
        newState = state;
    }
    return newState;
};

export default accountInvoiceTableReducer;
